import { render } from "./LogoGwdi.vue?vue&type=template&id=562f5d0d&scoped=true"
const script = {}

import "./LogoGwdi.vue?vue&type=style&index=0&id=562f5d0d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-562f5d0d"

export default script